import { useDispatch } from 'react-redux';

import analytics from '@ad-scripts/lib/analytics';
import ivrsResource from 'src/actions/ivrs/ivrsResource';
import { toastError } from 'src/actions/toast';

export default function useArchiveIvr() {
  const dispatch = useDispatch();
  const archiveIvr = (item, archivedAt = '') => {
    const id = item.id;

    if (item.isActive) {
      dispatch(toastError('IVR is active, please deactivate it before archiving.'));
      return;
    }
    archivedAt = archivedAt || new Date().toISOString();
    dispatch(
      ivrsResource.effects.archiveIvr(
        {
          id,
          toastSuccess: 'Archive successful!',
          toastError: 'There was an error while archiving',
        },
        { archivedAt }
      )
    );
    analytics.track('Admin - IVR Archive', { ivrId: id });
  };

  const unarchiveIvr = item => {
    if (!item.archivedAt) {
      dispatch(toastError('IVR is not archived.'));
      return;
    }

    dispatch(
      ivrsResource.effects.archiveIvr(
        { id: item.id, toastSuccess: 'Unarchive successful!', toastError: 'There was an error while unarchiving' },
        { archivedAt: '' }
      )
    );
    analytics.track('Admin - IVR Unarchive', { ivrId: item.id });
  };

  return { archiveIvr, unarchiveIvr };
}
